__turbopack_context__.v({
  "action": "ConferenceCallPopup-module-scss-module__lCqrEq__action",
  "draggableWrapper": "ConferenceCallPopup-module-scss-module__lCqrEq__draggableWrapper",
  "main": "ConferenceCallPopup-module-scss-module__lCqrEq__main",
  "person": "ConferenceCallPopup-module-scss-module__lCqrEq__person",
  "personImg": "ConferenceCallPopup-module-scss-module__lCqrEq__personImg",
});
